module.exports = __webpack_public_path__ + "static/img/6547_phase_function_Paper_Points.4e21443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6547_phase_function_Paper_Points.png
// module id = wntv
// module chunks = 0